import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getProduct } from '../selectors';
import styles from '../css/product.module.css';
import { Card, makeStyles } from '@material-ui/core';
import AddToCart from '../components/AddToCart';

const useStyles = makeStyles({
    root: {
        background: 'var(--bg-gradient)',
        padding: '1rem',
        gridArea: 'img',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
const Product = (props) => {
    const { id } = useParams();
    const product = useSelector((state) => getProduct(state, id));
    const classes = useStyles();
    return (
        <>
            {product && (
                <div className={styles.bg}>
                    <Card className={classes.root}>
                        <img
                            className={styles.img}
                            src="https://firebasestorage.googleapis.com/v0/b/windsor-liquor.appspot.com/o/Liquors%2Fwine.png?alt=media"
                            alt={`product id: ${id}`}
                        />
                    </Card>
                    <div className={styles.title_container}>
                        <h1 className={styles.name}>{product.name}</h1>
                        <span className={styles.size}>
                            {product.size && product.size}
                            {product.pack && ', ' + product.pack}
                        </span>
                    </div>
                    <div className={styles.action_container}>
                        <span className={styles.price}>
                            {'$' + product.salePrice}
                        </span>
                        <AddToCart sku={product.sku} history={props.history} />
                    </div>
                    <div className={styles.details_container}>
                        {Object.keys(product).map((key) => {
                            if (
                                key === 'img' ||
                                key === 'name' ||
                                key === 'salePrice'
                            ) {
                                return null;
                            }
                            return (
                                <div className={styles.details_row} key={key}>
                                    <div className={styles.details_label}>
                                        {key}
                                    </div>
                                    <div className={styles.details_text}>
                                        {product[key]}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default Product;
